/* @generated */
// prettier-ignore
if (Intl.RelativeTimeFormat && typeof Intl.RelativeTimeFormat.__addLocaleData === 'function') {
  Intl.RelativeTimeFormat.__addLocaleData({
    "data": {
      "day": {
        "-1": "duh",
        "0": "îro",
        "1": "sibe",
        "future": {
          "other": "+{0} d"
        },
        "past": {
          "other": "-{0} d"
        }
      },
      "day-narrow": {
        "-1": "duh",
        "0": "îro",
        "1": "sibe",
        "future": {
          "other": "+{0} d"
        },
        "past": {
          "other": "-{0} d"
        }
      },
      "day-short": {
        "-1": "duh",
        "0": "îro",
        "1": "sibe",
        "future": {
          "other": "+{0} d"
        },
        "past": {
          "other": "-{0} d"
        }
      },
      "hour": {
        "0": "this hour",
        "future": {
          "other": "+{0} h"
        },
        "past": {
          "other": "-{0} h"
        }
      },
      "hour-narrow": {
        "0": "this hour",
        "future": {
          "other": "+{0} h"
        },
        "past": {
          "other": "-{0} h"
        }
      },
      "hour-short": {
        "0": "this hour",
        "future": {
          "other": "+{0} h"
        },
        "past": {
          "other": "-{0} h"
        }
      },
      "minute": {
        "0": "this minute",
        "future": {
          "other": "+{0} min"
        },
        "past": {
          "other": "-{0} min"
        }
      },
      "minute-narrow": {
        "0": "this minute",
        "future": {
          "other": "+{0} min"
        },
        "past": {
          "other": "-{0} min"
        }
      },
      "minute-short": {
        "0": "this minute",
        "future": {
          "other": "+{0} min"
        },
        "past": {
          "other": "-{0} min"
        }
      },
      "month": {
        "-1": "meha borî",
        "0": "vê mehê",
        "1": "meha were",
        "future": {
          "other": "+{0} m"
        },
        "past": {
          "other": "-{0} m"
        }
      },
      "month-narrow": {
        "-1": "meha br.",
        "0": "vê mehê",
        "1": "meha bê",
        "future": {
          "one": "+{0} m",
          "other": "+{0} m"
        },
        "past": {
          "one": "-{0} m",
          "other": "-{0} m"
        }
      },
      "month-short": {
        "-1": "meha br.",
        "0": "vê mehê",
        "1": "meha bê",
        "future": {
          "one": "+{0} m",
          "other": "+{0} m"
        },
        "past": {
          "one": "-{0} m",
          "other": "-{0} m"
        }
      },
      "nu": ["latn"],
      "quarter": {
        "-1": "last quarter",
        "0": "this quarter",
        "1": "next quarter",
        "future": {
          "other": "+{0} Q"
        },
        "past": {
          "other": "-{0} Q"
        }
      },
      "quarter-narrow": {
        "-1": "last quarter",
        "0": "this quarter",
        "1": "next quarter",
        "future": {
          "other": "+{0} Q"
        },
        "past": {
          "other": "-{0} Q"
        }
      },
      "quarter-short": {
        "-1": "last quarter",
        "0": "this quarter",
        "1": "next quarter",
        "future": {
          "other": "+{0} Q"
        },
        "past": {
          "other": "-{0} Q"
        }
      },
      "second": {
        "0": "now",
        "future": {
          "other": "+{0} s"
        },
        "past": {
          "other": "-{0} s"
        }
      },
      "second-narrow": {
        "0": "now",
        "future": {
          "other": "+{0} s"
        },
        "past": {
          "other": "-{0} s"
        }
      },
      "second-short": {
        "0": "now",
        "future": {
          "other": "+{0} s"
        },
        "past": {
          "other": "-{0} s"
        }
      },
      "week": {
        "-1": "hefteya borî",
        "0": "vê hefteyê",
        "1": "hefteya were",
        "future": {
          "other": "+{0} w"
        },
        "past": {
          "other": "-{0} w"
        }
      },
      "week-narrow": {
        "-1": "hft. borî",
        "0": "vê hft.",
        "1": "hft. bê",
        "future": {
          "other": "+{0} w"
        },
        "past": {
          "other": "-{0} w"
        }
      },
      "week-short": {
        "-1": "hft. borî",
        "0": "vê hft.",
        "1": "hft. bê",
        "future": {
          "other": "+{0} w"
        },
        "past": {
          "other": "-{0} w"
        }
      },
      "year": {
        "-1": "par",
        "0": "îsal",
        "1": "sala piştî",
        "future": {
          "one": "di salekê de",
          "other": "di {0} salan de"
        },
        "past": {
          "one": "berî {0} salê",
          "other": "berî {0} salan"
        }
      },
      "year-narrow": {
        "-1": "par",
        "0": "îsal",
        "1": "sala bê",
        "future": {
          "one": "piştî salekê",
          "other": "piştî {0} salan"
        },
        "past": {
          "one": "berî salekê",
          "other": "berî {0} salan"
        }
      },
      "year-short": {
        "-1": "par",
        "0": "îsal",
        "1": "sala bê",
        "future": {
          "one": "piştî salekê",
          "other": "piştî {0} salan"
        },
        "past": {
          "one": "berî salekê",
          "other": "berî {0} salan"
        }
      }
    },
    "locale": "ku"
  });
}